import MyProceduresModulePage from './my-procedures/MyProceduresModulePage';

export default MyProceduresModulePage;
